import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import List from "@/components/List.vue";
import RichCourseItem from "@/modules/stu/components/rich/CourseItem.vue";
import Classify from "@/modules/stu/components/Classify.vue";
import ListSort from "@/modules/stu/components/ListSort.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import VipSort from "@/modules/stu/components/VipSort.vue";
export default {
  name: "Course",
  components: {
    List: List,
    Classify: Classify,
    RichCourseItem: RichCourseItem,
    SearchKeyWords: SearchKeyWords,
    ListSort: ListSort,
    VipSort: VipSort
  },
  data: function data() {
    return {
      classifyList: [],
      classify: 0,
      subClassify: 0,
      attrCondition: {},
      attrs: [],
      courseClassifyData: {},
      sort: 0,
      courseType: this.$route.name == "OpenCourse" || this.$route.query.title == "公开课" ? 3 : 1,
      // 默认普通课程
      recommend: this.$route.query.recommend,
      vipCourse: {}
    };
  },
  computed: {
    isOpen: function isOpen() {
      return this.courseType == 3;
    },
    keywords: function keywords() {
      return this.$route.query.keywords;
    },
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    classifyItems: function classifyItems() {
      var _this = this;

      var items = [];
      items.push({
        id: "classify",
        name: "课程分类",
        value: {
          item: this.classify,
          child: this.subClassify
        },
        children: this.classifyList
      });
      this.attrs.forEach(function (c) {
        var item = {
          id: c.id,
          name: c.name,
          value: {
            item: _this.attrCondition[c.id]
          },
          children: c.child
        };
        items.push(item);
      });
      return items;
    },
    params: function params() {
      var params = {
        course_type: this.courseType,
        classify_id: this.subClassify || this.classify,
        keywords: this.keywords,
        order_by: this.sort
      };
      console.log(params);

      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }

      var attrValIds = [];

      for (var key in this.attrCondition) {
        var valId = this.attrCondition[key];

        if (valId != 0) {
          attrValIds.push(valId);
        }
      }

      params.attr_val_id = attrValIds.join(",");

      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      } // 会员免费课筛选项


      params.is_vip = this.vipCourse.checked ? 1 : 0;

      if (this.vipCourse.vipLevel) {
        params.vip_id = this.vipCourse.vipLevel;
      }

      return params;
    }
  },
  watch: {
    keywords: function () {
      var _keywords = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getCourse(true);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function keywords() {
        return _keywords.apply(this, arguments);
      }

      return keywords;
    }(),
    $route: function () {
      var _$route = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$nextTick();

              case 2:
                this.init();
                _context2.next = 5;
                return this.getClassify();

              case 5:
                this.courseType = this.$route.name != "OpenCourse" && this.$route.query.recommend != 3 ? 1 : 3;
                _context2.next = 8;
                return this.getCourse(true);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function $route() {
        return _$route.apply(this, arguments);
      }

      return $route;
    }(),
    sort: function sort() {
      this.getCourse(true);
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.init();
              _context3.next = 3;
              return this.getClassify();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    this.$kefu();
  },
  methods: {
    init: function init() {
      this.classify = 0;
      this.subClassify = 0;
      this.course_type = this.$route.query.course_type || 0;
      this.recommend = this.$route.query.recommend; //会员页面点击更多跳转到课程列表页，默认选中会员

      if (this.$route.query.vip) {
        this.vipCourse.checked = true;
        this.vipCourse.vipLevel = this.$route.query.vip_id ? parseInt(this.$route.query.vip_id) : "";
      }
    },
    getClassify: function () {
      var _getClassify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var params, data, attrs;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {};

                if (this.$route.query.nav) {
                  params.nav_id = this.$route.query.nav;
                }

                if (this.$route.query.recommend) {
                  params.recommend = this.$route.query.recommend;
                }

                _context4.next = 5;
                return this.$http.get("/api/app/courseClassify", params);

              case 5:
                data = _context4.sent;
                data.classify.unshift({
                  id: 0,
                  name: "全部"
                });
                data.classify.forEach(function (c) {
                  if (!c.children) {
                    return;
                  }

                  c.children.unshift({
                    id: 0,
                    name: "全部"
                  });
                });
                this.classifyList = data.classify;
                this.courseClassifyData = data;
                attrs = data.attrclassify;
                attrs.forEach(function (attr) {
                  attr.child.unshift({
                    id: 0,
                    name: "全部"
                  });

                  _this2.$set(_this2.attrCondition, attr.id, 0);
                });
                this.attrs = attrs;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getClassify() {
        return _getClassify.apply(this, arguments);
      }

      return getClassify;
    }(),
    getCourse: function getCourse() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (refresh) {
        this.$refs.list.searchRefresh();
      }
    },
    onClassifyChange: function onClassifyChange(_ref) {
      var id = _ref.id,
          value = _ref.value;

      if (id == "type") {
        this.courseType = value.item;
      } else if (id == "classify") {
        this.classify = value.item;
        this.subClassify = value.child;
      } else {
        this.attrCondition[id] = value.item;
      }

      console.log(123, this.classify);
      this.getCourse(true);
    },
    changeVipSort: function changeVipSort(data) {
      this.vipCourse = data;
      this.getCourse(true);
    }
  }
};